import React from "react";
import "../../Styles/yellowcalf.css/Failed_Transactions.css";
function Failed_Transactions() {
  return (
    <div class="failed-transactions-container" style={{ paddingTop: "25px" }}>
      <div class="failed-transactions-panel">
        <div class="failed-transactions-header ">
          <h4><b>Parent Failed Transactions</b></h4>
          <a href="/accountant/checktransaction">
            <input type="submit" value="Check Status" />
          </a>
        </div>
      </div>

      <div className="d-flex flex-wrap gap-3">
        <select className="parent-fail-filter form-control-sm">
          <option>Select Student</option>
          <option>Sample</option>
          <option>Minni</option>
        </select>

        <select className="parent-fail-filter form-control-sm">
          <option>Select Division</option>
          <option>A</option>
          <option>B</option>
        </select>

        <select className="parent-fail-filter form-control-sm">
          <option>Select Mode</option>
          <option>Paypal</option>
          <option>Paytm</option>
        </select>

       <button type="button" className="btn custom-btn btn-sm">
          Clear
        </button>

      </div>

      <div class="failed-transactions-panel-table">
        <div class="failed-transactions-table-container">
          <table class="failed-transactions-table">
            <thead>
              

                  <tr>
                    <th>Sr.no</th>
                    <th>Paid By User</th>
                    <th>Student Name</th>
                    <th>Grade</th>
                    <th>Division</th>
                    <th>Transaction Id</th>
                    <th>Payment For</th>
                    <th>Transaction Date</th>
                    <th>Transaction Mode</th>
                    <th>Action</th>
                  </tr>


                </thead>

                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Sarin Pradeep</td>
                    <td>Neha Pethkar</td>
                    <td>6th</td>
                    <td>A</td>
                    <td>1607F616</td>
                    <td>Fees</td>
                    <td>15 Mar 2021</td>
                    <td>Paypal</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <a className="failed-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="View Receipt"
                      >
                        <i class="bi bi-eye"></i></a>

                      <a className="failed-reload-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="Reload Transation"
                      >
                        <i class="bi bi-arrow-clockwise"></i></a>
                    </td>

                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Sarin Pradeep</td>
                    <td>Neha Pethkar</td>
                    <td>6th</td>
                    <td>A</td>
                    <td>1607F836</td>
                    <td>Fees</td>
                    <td>15 Mar 2021</td>
                    <td>Paypal</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <a className="failed-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="View Receipt"
                      >
                        <i class="bi bi-eye"></i></a>

                      <a className="failed-reload-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="Reload Transation"
                      >
                        <i class="bi bi-arrow-clockwise"></i></a>
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Sarin Pradeep</td>
                    <td>Neha Pethkar</td>
                    <td>6th</td>
                    <td>A</td>
                    <td>1607F836</td>
                    <td>Fees</td>
                    <td>15 Mar 2021</td>
                    <td>Paypal</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <a className="failed-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="View Receipt"
                      >
                        <i class="bi bi-eye"></i></a>

                      <a className="failed-reload-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="Reload Transation"
                      >
                        <i class="bi bi-arrow-clockwise"></i></a>
                    </td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Sarin Pradeep</td>
                    <td>Neha Pethkar</td>
                    <td>6th</td>
                    <td>A</td>
                    <td>1607F836</td>
                    <td>Fees</td>
                    <td>15 Mar 2021</td>
                    <td>Paypal</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <a className="failed-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="View Receipt"
                      >
                        <i class="bi bi-eye"></i></a>

                      <a className="failed-reload-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="Reload Transation"
                      >
                        <i class="bi bi-arrow-clockwise"></i></a>
                    </td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Sarin Pradeep</td>
                    <td>Neha Pethkar</td>
                    <td>6th</td>
                    <td>A</td>
                    <td>1607F836</td>
                    <td>Fees</td>
                    <td>15 Mar 2021</td>
                    <td>Paypal</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <a className="failed-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="View Receipt"
                      >
                        <i class="bi bi-eye"></i></a>

                      <a className="failed-reload-Transaction-view-btn"
                        href="/accountant/parenttransactions/failedtransactionrecept"
                        title="Reload Transation"
                      >
                        <i class="bi bi-arrow-clockwise"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="wallet-main-footer">
                <ul className="wallet-main-pagination">
                  <li className="wallet-main-active">
                    <a href="#">1</a>
                  </li>
                  <li>
                    <a href="#">2</a>
                  </li>
                  <li>
                    <a href="#">3</a>
                  </li>
                </ul>

                <div className="wallet-main-summary">
                  Showing <b>1-50</b> of <b>177</b> items.
                </div>
              </div>
            </div>
        </div>
      </div>
      );
}

      export default Failed_Transactions;
